import Http from "@/commons/Http";

const path = 'api/configuration';

export default {

    async getLoginPageConfiguration(){
        return Http.get(`${path}/login-page`);
    },

    async saveLoginPageConfiguration(dto){
        return Http.post(`${path}/login-page`, dto);
    },

}